import React from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { format, isBefore, parse, startOfDay } from 'date-fns';
import { FormFieldName, FormModel, FormSubmitTrigger } from '../form';
import { DATE_VALUE_FORMAT } from '../const';

export const useDate = ({ form, submit }: { form: UseFormReturn<FormModel>; submit: FormSubmitTrigger }) => {
  const dateValue = useWatch<FormModel, FormFieldName.Date>({ name: FormFieldName.Date });

  /**
   * Checks to keep form in a consistent state
   */
  React.useEffect(() => {
    if (!dateValue) {
      return;
    }

    const date = parse(dateValue, DATE_VALUE_FORMAT, new Date());
    const startOfToday = startOfDay(new Date());

    if (isBefore(date, startOfToday)) {
      form.setValue(FormFieldName.Date, format(startOfToday, DATE_VALUE_FORMAT));
      submit();
    }
  }, [dateValue, form, submit]);
};
